import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-verification-dialog',
    templateUrl: './verification-dialog.component.html',
    styleUrls: ['./verification-dialog.component.scss']
})
export class VerificationDialogComponent {

    verificationLoading = false;

    constructor(
        public matDialogRef: MatDialogRef<VerificationDialogComponent>
    ) {
        this.matDialogRef.addPanelClass('no-padding-dialog-container');
    }

    onLoadingChange(isLoading: boolean): void {
        this.verificationLoading = isLoading;
    }

    close(): void {
        this.matDialogRef.close(true);
    }
}
